export enum PreviewPathEnum {
  PREVIEW = "/preview/:contentfulId",
}
